import { gql } from '@apollo/client';

export const GET_MAJORS_LIST = gql`
  query GetMajorsList {
    majors {
      edges {
        node {
          id
          pk
          name
        }
      }
    }
  }
`;

export const GET_GOVERNORATES_LIST = gql`
  query GetGovernoratesList {
    governorates {
      edges {
        node {
          id
          pk
          name
        }
      }
    }
  }
`;

export const GET_AREAS_LIST = gql`
  query GetAreasList {
    areas {
      edges {
        node {
          id
          pk
          name
          governorate {
            pk
            name
          }
        }
      }
    }
  }
`;

export const GET_INITIATIVES_LIST = gql`
  query GetInitiativesList {
    initiatives {
      edges {
        node {
          id
          pk
          englishName
          arabicName
          englishDescription
          arabicDescription
          startingDate
          endingDate
          image
          registrationClosed
          ageFrom
          ageTo
        }
      }
    }
  }
`;

export const GET_INITIATIVE_DETAILS = gql`
  query GetInitiativeDetails($id: ID!) {
    initiative(id: $id) {
      id
      pk
      englishName
      arabicName
      englishDescription
      arabicDescription
      startingDate
      endingDate
      image
      contractEn
      contractAr
      registrationClosed
      ageFrom
      ageTo
      location {
        id
        pk
        nameAr
        nameEn
      }
      tag {
        id
        pk
        title
      }
      startingTime
      endingTime
      steps {
        id
        step {
          pk
          title
          description
          shouldBook
        }
        order
      }
      shifts {
        edges {
          node {
            id
            pk
            startingDate
            endingDate
            startingTime
            endingTime
            checkInEarliest
            checkInLatest
            checkOutLatest
          }
        }
      }
      relatedDocs {
        edges {
          node {
            id
            pk
            title
            file
          }
        }
      }
      roles {
        edges {
          node {
            id
            pk
            title
            probationHours
            probationHourRate
            afterProbationRate
            afterProbationRateType
            daysOff
          }
        }
      }
    }
  }
`;

export const GET_STEPS_LIST = gql`
  query GetStepsList {
    steps {
      edges {
        node {
          id
          pk
          title
          description
          shouldBook
          shouldAddResults
        }
      }
    }
  }
`;

export const GET_TAGS_LIST = gql`
  query GetTagsList {
    tags {
      edges {
        node {
          pk
          id
          title
          description
        }
      }
    }
  }
`;

export const GET_LEVELS_LIST = gql`
  query GetLevelsList {
    levels {
      edges {
        node {
          pk
          id
          title
          description
        }
      }
    }
  }
`;

export const GET_GUIDE_STATUS_LIST = gql`
  query GetGuideStatusList {
    guideStatus {
      edges {
        node {
          pk
          id
          title
          description
        }
      }
    }
  }
`;

export const GET_INITIATIVE_SLOTS_LIST = gql`
  query GetInitiativeSlotsList {
    timeSlots {
      edges {
        node {
          pk
          id
          date
          startingTime
          endingTime
          capacity
          platform
          location
          locationDetails
          initiativeStep {
            step {
              title
            }
          }
        }
      }
    }
  }
`;

export const GET_LOCATIONS_LIST = gql`
  query GetLocationsList($isMainLocation: Boolean, $isActive: Boolean) {
    locations(isMainLocation: $isMainLocation, isActive: $isActive) {
      edges {
        node {
          pk
          id
          nameEn
          nameAr
          isActive
          mapUrl
          governorate
          area
          mainLocationAddress
          point1
          point2
          point3
          point4
          latitude
          longitude
          radius
          subLocations {
            id
            nameAr
            nameEn
            governorate
            area
            mapUrl
            point1
            point2
            point3
            point4
          }
        }
      }
    }
  }
`;

export const GET_LOCATION_DETAILS = gql`
  query GetLocationDetails($initiativeId: Int) {
    location(initiativeId: $initiativeId) {
      pk
      id
      nameAr
      nameEn
      isActive
      governorate
      subLocations {
        id
        nameAr
        nameEn
        governorate
        area
      }
      area
      mapUrl
    }
  }
`;

export const GET_INITIATIVE_SHIFTS_LIST = gql`
  query GetInitiativeShiftsList($initiativeId: Int) {
    shifts(initiativeId: $initiativeId) {
      edges {
        node {
          id
          pk
          startingDate
          endingDate
          startingTime
          endingTime
        }
      }
    }
  }
`;

export const GET_INITIATIVE_ROLES_LIST = gql`
  query GetInitiativeRolesList($initiativeId: Int) {
    roles(initiativeId: $initiativeId) {
      edges {
        node {
          id
          pk
          title
          initiative {
            englishName
            startingDate
            endingDate
          }
        }
      }
    }
  }
`;

export const GET_INITIATIVE_USHER_DETAILS = gql`
  query GetInitiativeUsherDetails(
    $userId: ID
    $initiativeId: ID
    $initiativeUsherId: ID
  ) {
    initiativeUshers(
      userId: $userId
      initiativeId: $initiativeId
      initiativeUsherId: $initiativeUsherId
    ) {
      edges {
        node {
          pk
          id
          status
          assignedLocation {
            nameEn
          }
          assignedRole {
            title
          }
          assignedShift {
            startingDate
            endingDate
            startingTime
            endingTime
          }
          initiative {
            pk
            englishName
            startingDate
            endingDate
          }
          usher {
            englishFullName
            usherId
            mobileNumber
            currentAge
          }
        }
      }
    }
  }
`;

export const GET_ATTENDANCE_HISTORY_LIST = gql`
  query GetAttendanceHistoryList($initiativeUsherId: Decimal!) {
    attendanceHistory(initiativeUsherId: $initiativeUsherId) {
      edges {
        node {
          pk
          id
          date
          checkInTime
          checkOutTime
          status
          comments
        }
      }
    }
  }
`;

export const GET_ALL_ATTENDANCE_HISTORY_LIST = gql`
  query GetAllAttendanceHistoryList(
    $offset: Int
    $first: Int
    $dateAfter: Date
    $dateBefore: Date
    $role: Decimal
    $search: String
    $incompleteCheckout: Boolean
    $checkinStatus: String
    $checkoutStatus: String
    $status: String
  ) {
    attendanceHistory(
      offset: $offset
      first: $first
      dateAfter: $dateAfter
      dateBefore: $dateBefore
      role: $role
      search: $search
      incompleteCheckout: $incompleteCheckout
      checkinStatus: $checkinStatus
      checkoutStatus: $checkoutStatus
      status: $status
    ) {
      totalCount
      checkinAndCheckoutCount
      checkinOnlyCount
      totalPending
      totalApproved
      totalRejected
      edges {
        node {
          pk
          id
          status
          checkInTime
          date
          checkOutTime
          checkoutDate
          checkinStatus
          checkoutStatus
          snapshotCheckedIn
          snapshotCheckedOut
          faceMatchScoreCheckedIn
          faceMatchScoreCheckedOut
          comments
          initiativeUsher {
            usher {
              englishFullName
              civilId
              personalImage
              usherId
              mobileNumber
              user {
                email
                referenceImage
              }
            }
            assignedShift {
              startingTime
              endingTime
              startingDate
              endingDate
            }
          }
        }
      }
    }
  }
`;

export const GET_HISTORY = gql`
  query GetHistory($userID: String!) {
    registrations(userId: $userID) {
      edges {
        node {
          id
          pk
          programTitle
          programTitleAr
          programCategory
          status
          registeredOn
          exitSurvey
          totalHours
          program {
            pk
            certificateSource
            startingDate
            endingDate
          }
          applicant {
            firstName
            lastName
          }
        }
      }
    }

    LSVRegistrations(userId: $userID) {
      edges {
        node {
          id
          pk
          programTitle
          programTitleAr
          status
          registeredOn
          exitSurvey
          totalDays
          initiative {
            pk
            startingDate
            endingDate
          }
          usher {
            englishFullName
          }
          programCategory
        }
      }
    }
  }
`;

export const GET_COMMUNICATION_HISTORY_LIST = gql`
  query GetCommunicationHistoryList($initiativeUsherId: Decimal!) {
    communicationHistory(initiativeUsherId: $initiativeUsherId) {
      edges {
        node {
          pk
          id
          date
          time
          communicationMethod
          comments
        }
      }
    }
  }
`;

export const GET_INITIATIVE_USHER_STEP = gql`
  query GetInitiativeUsherStep(
    $initiativeUsherId: ID!
    $initiativeStepId: ID!
  ) {
    initiativeUshersStep(
      initiativeUsherId: $initiativeUsherId
      initiativeStepId: $initiativeStepId
    ) {
      pk
      status
      nonCompletionReason
      comments
      hasResults
      resultsId
    }
  }
`;

export const GET_INITIATIVE_USHER_STEP_RESULT = gql`
  query GetInitiativeUsherStepResult($id: ID!) {
    initiativeUsherStepResult(id: $id) {
      id
      interviewDate
      interviewTime
      assessorName
      generalComments
      englishLevel
      arabicLevel
      workExperience
      workExperienceComments
      volunteeringExperience
      volunteeringExperienceComments
      applyReasons
      interviewerSectionComments
      dealingWithKidsRating
      dealingWithKidsComments
      leadershipSkillsRating
      leadershipSkillsComments
      stressfulSituationsRating
      stressfulSituationsComments
      socialIntelligenceRating
      socialIntelligenceComments
      unfairLeaderRating
      unfairLeaderComments
      confidenceRating
      confidenceComments
      enthusiasmRating
      enthusiasmComments
      speakingVolumeRating
      speakingVolumeComments
      eyeContactRating
      eyeContactComments
      decision
      rate
      finalComments
      step {
        initiativeUsher {
          initiative {
            englishName
          }
          usher {
            usherId
            englishFullName
          }
        }
      }
    }
  }
`;
